import { Component, Inject, OnInit } from "@angular/core";
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import { RolesDialogeComponent } from "src/app/views/roles-dialoge/roles-dialoge.component";
import { HttpClient } from "@angular/common/http";
import { CdkDragDrop, transferArrayItem } from "@angular/cdk/drag-drop";

@Component({
  selector: "app-security-pop-up",
  templateUrl: "./security-pop-up.component.html",
  styleUrls: ["./security-pop-up.component.css"],
})
export class SecurityPopUpComponent implements OnInit {

  constructor(
    private httpClient: HttpClient,
    public dialogRef: MatDialogRef<RolesDialogeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  unAssigendRole: any[];
  assigendRoles = [];
  rolesList = null;
  ngOnInit() {
    this.unAssigendRole = this.data.unassigendRole;
    this.assigendRoles = this.data.assigendRoles || [];
    if(this.data.isComponent)
    this.loadScript();
  }
  getRoles() {
    this.httpClient.get("/RolesManagement/GetRoles").subscribe((res: any) => {
      this.rolesList = res;
    });
  }
  loadScript() {
    const head = document.getElementsByTagName("head")[0];
    const script = document.createElement("link");
    script.href = "./assets/plugins/custom/kanban/kanban.bundle.css";
    script.rel = "stylesheet";
    script.type = "text/css";
    var oldJs = document.getElementsByTagName("link");
    for (let index = 0; index < oldJs.length; index++) {
      const element = oldJs[index];
      if (element.href.indexOf("kanban.bundle.css") != -1) {
        head.removeChild(element);
        index = index - 1;
      }
    }
    head.appendChild(script);
  }
  // assignRole(e) {
  //   for (let i = 0; i < this.unAssigendRole.length; i++) {
  //     const unAssRole = this.unAssigendRole[i];
  //     if (unAssRole.id == e.dragData.id) {
  //       this.unAssigendRole.splice(i, 1);
  //     }
  //   }
  //   this.assigendRoles.push(e.dragData);
  // }
  // unAssignRole(e: any) {
  //   for (let i = 0; i < this.assigendRoles.length; i++) {
  //     const unAssRole = this.assigendRoles[i];
  //     if (unAssRole.id == e.dragData.id) {
  //       this.assigendRoles.splice(i, 1);
  //     }
  //   }
  //   this.unAssigendRole.push(e.dragData);
  // }
  assignRole(event: CdkDragDrop<any[]>) {
    if (event.previousContainer !== event.container) {
      // Moving item from unassigned roles to assigned roles
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  unAssignRole(event: CdkDragDrop<any[]>) {
    if (event.previousContainer !== event.container) {
      // Moving item from assigned roles to unassigned roles
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }
  save(): void {
    var data = {
      unassigendRole: this.unAssigendRole,
      assigendRoles: this.assigendRoles,
    };

    this.dialogRef.close(data);
  }
  close() {
    this.dialogRef.close();
  }

}
